module.exports = __webpack_public_path__ + "static/img/protitle.6dee58d.png";


//////////////////
// WEBPACK FOOTER
// ./static/mobile/protitle.png
// module id = g+w+
// module chunks = 1